import { render, staticRenderFns } from "./revoke-cancel.vue?vue&type=template&id=216e457f&"
import script from "./revoke-cancel.vue?vue&type=script&lang=js&"
export * from "./revoke-cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports